export const skuManagementApiRoutes = {
  getFilters: '/v1/should-cost-analysis/get-sku-filters',
  getKPIs: '/v1/should-cost-analysis/get-kpi',
  getSkuTable: '/v1/should-cost-analysis/get-sku-master-data-list',
  getTotalSKUCount: '/v1/should-cost-analysis/get-total-sku-count',
  getDpcdData: '/v2/should-cost-analysis/get-dpcd-data'
}

export const uploadApiRoutes = {
  getShouldCostModelsBySku: '/v1/should-cost-analysis/get-shouldcost-models-by-sku',
  setModelFinal: '/v1/should-cost-analysis/set-final-model',
  downloadFile: 'v1/should-cost-analysis/download-template',
  uploadFile: '/v1/should-cost-analysis/upload-files',
  validateFile: '/v1/should-cost-analysis/validate-files',
}

export const poTrendsApiRoutes = {
  getTrendsData: '/v1/should-cost-analysis/get-vendor-po-data',
  getTrendsLineChartData: '/v1/should-cost-analysis/get-po-trend-data',
}

export const createShouldCostApiRoutes = {
  getCreateShouldCostView: '/v1/should-cost-analysis/get-detailed-should-cost-by-product',
  createShouldCostModel: '/v1/should-cost-analysis/save-breakdown',
  getCountries: '/v1/conversion/countries',
  getShouldCostModels: '/v1/should-cost-analysis/get-models-by-filters',
  getMaxDate: 'v1/should-cost-analysis/get-commodity-max-date',
  getShouldCostBreakdownForModel: '/v1/should-cost-analysis/get-should-cost-breakdown',
  editShouldCostModel: '/v1/should-cost-analysis/edit-should-cost',
  getSkuAttachments: 'v1/should-cost-analysis/get-sku-attachments',
  downloadSkuFile: '/v1/should-cost-analysis/download-adls-file',
  getStandardTaxonomy: '/v1/should-cost-analysis/get-taxonomy-categories',
  getModelMetaData: 'v1/should-cost-analysis/get-model-meta-data',
  getTotalModelCount: '/v1/should-cost-analysis/get-total-model-count',
  getTotalSKURowsCount: 'v1/buildShouldCost/getSkuRowsTotalCount',
}
export const commodityApiRoutes = {
  commodityData: '/v1/should-cost-analysis/get-commodity',
  commodityKPIs: '/v1/should-cost-analysis/commodity-kpi',
}

export const viewShouldCostApiRoutes = {
  trendLine: '/v1/should-cost-analysis/mini-ifa',
  checkIfaProgress: '/v2/should-cost-analysis/is-calulating',
  downloadShouldCost: '/v1/should-cost-analysis/download-should-cost',
  attachFilesToModel: '/v1/should-cost-analysis/get-should-cost-attachments',
  getAllVendorsForSku: '/v1/should-cost-analysis/get-all-vendors-for-sku',
  getAllVendorsForSkuByModel: '/v1/get-all-vendors-for-model',
  getChartCostSummaryDetails: '/v1/should-cost-analysis/get-should-cost-summary-chart',
  getBillOfMaterialDetails: '/v1/should-cost-analysis/get-bill-of-material-for-model',
  getShouldCostBreakdownDetails: '/v1/should-cost-analysis/get-chart-bom',
}

export const configurationPageApiRoutes = {
  getSkuLabelConfig: '/v1/should-cost-analysis/get_sku_label_config',
  setSkuLabelConfig: '/v1/should-cost-analysis/set_sku_label_config',
}

export const currencyApiRoutes = {
  getCurrencyExchangeRate: '/v1/should-cost-analysis/get-currency-exchange-rate',
}
